import ButtonIcon from "#common/buttons/ButtonIcon"
import { Box, Stack, Typography } from "@mui/material"
import { useState } from "react"
import { MainDetailsCommonContainer } from "./MainDetailsCommon"

export default function MainDetailsHeader({
	title,
	subtitle,
	chips,
	data,
	refresh,
	buttons = [],
	action,
	noUsePaper,
}) {
	const [open, setOpen] = useState(false)
	if (!data) return null

	const itemsDialog = []
	const itemsButton = buttons.map((item) => {
		const Dialog = item.component
		if (Dialog)
			itemsDialog.push(
				<Dialog
					key={item.title}
					{...{
						open: open === item.title,
						setOpen,
						profileData: data,
						refresh,
					}}
				/>
			)
		return (
			<ButtonIcon
				key={item.title}
				onClick={() => setOpen(item.title)}
				{...item}
				icon={<item.icon color={item?.color || "primary"} />}
				size="small"
			/>
		)
	})

	return (
		<MainDetailsCommonContainer {...{ noUsePaper }}>
			<Stack spacing={0}>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "flex-start",
					}}
				>
					<Box>
						<Typography variant="h6">{title}</Typography>
						<Typography variant="subtitle2">{subtitle}</Typography>
					</Box>
					<Box sx={{ display: "flex", gap: 1 }}>
						{itemsButton}
						{itemsDialog}
					</Box>
				</Box>
				<Stack
					direction={"row"}
					spacing={0}
					alignItems={"center"}
					justifyContent={"space-between"}
					width={"100%"}
				>
					<Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 0 }}>{chips}</Box>
					{action}
				</Stack>
			</Stack>
		</MainDetailsCommonContainer>
	)
}
